import React, { useEffect, useState } from "react";
import { TextInput, Button, Link } from "pepsico-ds";
import { useTranslation } from "react-i18next";
import "./auth.css";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";

function Login() {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  console.log("Login process started");
  useEffect(() => {
    const checkAuthenticationAndRedirect = async () => {
      console.log("Checking authentication status");
      localStorage.setItem("user logged status", "checking authentication " + new Date().toLocaleTimeString());
      const isAuthenticated = await oktaAuth.isAuthenticated();
      if (isAuthenticated) {  
        console.log("User is authenticated, navigating to /home");
        localStorage.setItem("user logged in ", "navigating to home " + new Date().toLocaleTimeString());
        navigate("/home");
      } else {
        await oktaAuth.signInWithRedirect();
        localStorage.setItem("user logged in ", "navigating to home " + new Date().toLocaleTimeString());
      }
    };
    checkAuthenticationAndRedirect();
  }, [oktaAuth, navigate]);
}

export default Login;
